import { render } from "./ssadd.vue?vue&type=template&id=56a307f2&scoped=true"
import script from "./ssadd.vue?vue&type=script&lang=js"
export * from "./ssadd.vue?vue&type=script&lang=js"

import "./ssadd.vue?vue&type=style&index=0&id=56a307f2&lang=scss&scoped=true"
import "./ssadd.vue?vue&type=style&index=1&id=56a307f2&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a307f2"]])

export default __exports__